import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import {
    inboxPlusDialogNewslettersDescription,
    inboxPlusDialogPromotionsDescription,
    inboxPlusDialogSocialDescription,
    inboxPlusDialogFocusOtherDescription,
} from '../components/PivotEnableDisableDialog.locstring.json';
import loc from 'owa-localize';

export default function getPivotToggleTooltipText(pivot: InboxClassificationFilter): string {
    switch (pivot) {
        case InboxClassificationFilter.Focused:
            return loc(inboxPlusDialogFocusOtherDescription);
        case InboxClassificationFilter.Promotions:
            return loc(inboxPlusDialogPromotionsDescription);
        case InboxClassificationFilter.Social:
            return loc(inboxPlusDialogSocialDescription);
        case InboxClassificationFilter.Newsletters:
            return loc(inboxPlusDialogNewslettersDescription);
        default:
            return null;
    }
}
